import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function Team() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Team
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Team Members
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Team Members
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Team-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Team overview
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Team-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Subteam Members
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Team-2-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Team Leader
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Team-2-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Finance and Entrepreneurship
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Team-2-3")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Dry Lab
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Team-2-4")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Wet Lab
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Team-2-5")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Human Practices
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Team-2-6")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Media and Communications
                                    </span>
                                </div>
                            </li>

                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Team-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Team overview
                        </div>
                        <img
                            src="https://static.igem.wiki/teams/5122/attributions/attribution-team.png"
                            className="w-full mt-8 rounded-2xl"
                            alt=""
                        />
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            Meet the iGem Stockholm team 2024. Our team includes 14 overgraduate students with
                            expertise from different fields, joined together by their interests in synthetic
                            biology!
                        </div>
                    </div>
                    <div>
                        <div id="Team-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Subteam members
                        </div>
                        <div id="Team-2-1" className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-felix.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Felix Falk
                                </div>
                                <div>
                                    Team Leader
                                </div>
                                <div>
                                    KTH, KI & SU
                                </div>
                                <div>
                                    Molecular Techniques in Life Science
                                </div>
                            </div>
                        </div>
                        <div id="Team-2-2" className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-dimitros.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Dimitros Tsagkogiannis
                                </div>
                                <div>
                                    Finance and Entrepreneurship
                                </div>
                                <div>
                                    Karolinska Institutet
                                </div>
                                <div>
                                    Translational Physiology and Pharmacology
                                </div>
                            </div>
                        </div>
                        <div className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-alex.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Aleksandras Gaudiesius
                                </div>
                                <div>
                                    Finance and Entrepreneurship
                                </div>
                                <div>
                                    Karolinska Institutet
                                </div>
                                <div>
                                    Bioentrepreneurship
                                </div>
                            </div>
                        </div>
                        <div id="Team-2-3" className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-jiaxin.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Jiaxin Wu
                                </div>
                                <div>
                                    Dry Lab
                                </div>
                                <div>
                                    KTH, KI & SU
                                </div>
                                <div>
                                    Molecular Techniques in Life Science
                                </div>
                            </div>
                        </div>
                        <div className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-mai.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Mai Nguyen
                                </div>
                                <div>
                                    Dry Lab
                                </div>
                                <div>
                                    KTH, KI & SU
                                </div>
                                <div>
                                    Molecular Techniques in Life Science
                                </div>
                            </div>
                        </div>
                        <div id="Team-2-4" className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-carmen.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Carmen de Ancos Jimeno
                                </div>
                                <div>
                                    Wet Lab
                                </div>
                                <div>
                                    KTH Royal Institute of Technology
                                </div>
                                <div>
                                    Medical Biotechnology
                                </div>
                            </div>
                        </div>
                        <div className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-maria.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Maria Gustavsson
                                </div>
                                <div>
                                    Wet Lab
                                </div>
                                <div>
                                    KTH, KI & SU
                                </div>
                                <div>
                                    Molecular Techniques in Life Science
                                </div>
                            </div>
                        </div>
                        <div className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-meghana.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Meghana Bhat
                                </div>
                                <div>
                                    Wet Lab
                                </div>
                                <div>
                                    KTH Royal Institute of Technology
                                </div>
                                <div>
                                    Biotechnology Engineering
                                </div>
                            </div>
                        </div>
                        <div className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-juliana.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Juliana Baranova
                                </div>
                                <div>
                                    Wet Lab
                                </div>
                                <div>
                                    Instituto de Química, USP, São Paulo, Brazil
                                </div>
                                <div>
                                    Doctoral program in Biochemistry
                                </div>
                            </div>
                        </div>
                        <div id="Team-2-5" className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-diandra.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Diandra Daumiller
                                </div>
                                <div>
                                    Human Practices
                                </div>
                                <div>
                                    KTH, KI & SU
                                </div>
                                <div>
                                    Molecular Techniques in Life Science
                                </div>
                            </div>
                        </div>
                        <div id="Team-2-6" className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-hongge.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Hongge Wang
                                </div>
                                <div>
                                    Media and Communications
                                </div>
                                <div>
                                    Karolinska Institutet
                                </div>
                                <div>
                                    Toxicology
                                </div>
                            </div>
                        </div>
                        <div className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-edna.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Edna Lam
                                </div>
                                <div>
                                    Media and Communications
                                </div>
                                <div>
                                    Karolinska Institutet
                                </div>
                                <div>
                                    Biomedicine
                                </div>
                            </div>
                        </div>
                        <div className="md:flex md:items-center">
                            <img
                                src="https://static.igem.wiki/teams/5122/attributions/attribution-teodora.png"
                                className="max-w-64 mt-8 rounded-2xl"
                                alt=""
                            />
                            <div className="md:mx-8 md:mt-0 mt-5 space-y-4 text-lg text-gray-600">
                                <div className="font-bold text-2xl text-gray-800">
                                    Teodora Pavlicu
                                </div>
                                <div>
                                    Media and Communications
                                </div>
                                <div>
                                    KTH, KI & SU
                                </div>
                                <div>
                                    Molecular Techniques in Life Science
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}